/**
 * @desc 分页
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.procurementRemark.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementRemark/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
